var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class SkuMappingApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'sku-mapping';
        this.apiBasePathV2 = 'v2/sku-mapping';
    }
    getMapping(collection) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall(Object.assign({ method: 'GET', route: this.apiBasePath }, (collection && { params: { collection } })));
        });
    }
    retrieveMapping(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}, invalidate = false) {
            const processedParams = params ? Object.assign(Object.assign({}, params), (params.groupId && Array.isArray(params.groupId)
                ? { groupId: params.groupId.join(',') }
                : {})) : undefined;
            return yield this.apiCall(Object.assign(Object.assign(Object.assign({ method: 'GET', route: this.apiBasePathV2 }, (processedParams && { params: processedParams })), (invalidate ? {
                customHeaders: {
                    'Cache-Control': 'max-age=0',
                },
            } : {})), options));
        });
    }
    findMappings(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}, invalidate = false) {
            const processedParams = params ? Object.assign(Object.assign({}, params), (Array.isArray(params.groupId) ? { groupId: params.groupId.join(',') } : {})) : undefined;
            return yield this.apiCall(Object.assign(Object.assign(Object.assign({ method: 'GET', route: `${this.apiBasePathV2}/manage` }, (processedParams && { params: processedParams })), (invalidate ? {
                customHeaders: { 'Cache-Control': 'max-age=0' },
            } : {})), options));
        });
    }
    approveMappings(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePathV2}/approve`,
                data: { ids },
            });
        });
    }
    getCategorySkuCodes(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePathV2}/category-sku-codes`,
                params,
            });
        });
    }
    createMapping(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: this.apiBasePathV2,
                data: payload,
            });
        });
    }
    updateMapping(id, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: this.apiBasePathV2,
                params: { id },
                data: payload,
            });
        });
    }
    deleteOne(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'DELETE',
                route: this.apiBasePathV2,
                params: { id },
            });
        });
    }
}
//# sourceMappingURL=index.js.map